var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { YandexGames } from './YandexGames';
export { YandexGames };
import { coinsById } from '../../../backend/src/utils/coinsById';
import { getLang } from '../../translate';
import { plural } from '../utils';
var Purchases = /** @class */ (function () {
    function Purchases() {
    }
    Object.defineProperty(Purchases, "signed", {
        set: function (signed) {
            if (FOR_YANDEX) {
                YandexGames.signed = signed;
            }
        },
        enumerable: false,
        configurable: true
    });
    Purchases.catalog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sale, lang;
            return __generator(this, function (_a) {
                if (FOR_YANDEX) {
                    return [2 /*return*/, YandexGames.getCatalog()];
                }
                if (FOR_VK) {
                    sale = false;
                    lang = getLang();
                    return [2 /*return*/, [
                            productData(sale ? '1' : '101', lang),
                            productData(sale ? '2' : '102', lang),
                            productData(sale ? '3' : '103', lang),
                        ]];
                }
                return [2 /*return*/, []];
            });
        });
    };
    Purchases.purchase = function (p) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (FOR_YANDEX) {
                    return [2 /*return*/, YandexGames.purchase(p.id)];
                }
                if (FOR_VK) {
                    // TODO ...
                }
                return [2 /*return*/];
            });
        });
    };
    Purchases.consume = function (purchase) {
        return __awaiter(this, void 0, void 0, function () {
            var coins;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!FOR_YANDEX) return [3 /*break*/, 2];
                        coins = coinsById(purchase.productID, false, true);
                        return [4 /*yield*/, YandexGames.consumePurchase(purchase.purchaseToken)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, coins];
                    case 2:
                        if (FOR_VK) {
                            // TODO ...
                        }
                        return [2 /*return*/, 0];
                }
            });
        });
    };
    Purchases.consumeByToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!FOR_YANDEX) return [3 /*break*/, 2];
                        return [4 /*yield*/, YandexGames.consumePurchase(token)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (FOR_VK) {
                            // TODO ...
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Purchases.get = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (FOR_YANDEX) {
                    return [2 /*return*/, YandexGames.getPurchases()];
                }
                if (FOR_VK) {
                    // TODO ...
                }
                return [2 /*return*/, []];
            });
        });
    };
    return Purchases;
}());
export { Purchases };
function productData(id, lang) {
    var price = priceById(id);
    return {
        id: id,
        // title: 'Горстка монет',
        // description: 'Небольшой набор монет для игры',
        // imageURI:
        //   'https://avatars.mds.yandex.net/get-games/2977039/2a00000178668ccc4a6e8e5d5b9b438e7e7a//default87x87',
        price: String(price),
        priceCurrencyCode: currencyCode(price, lang),
        priceValue: String(price),
    };
}
function priceById(id) {
    if (FOR_VK) {
        if (id === '101')
            return 2;
        if (id === '102')
            return 4;
        if (id === '103')
            return 6;
        if (id === '1')
            return 1;
        if (id === '2')
            return 2;
        if (id === '3')
            return 3;
    }
    return 0;
}
function currencyCode(price, lang) {
    return FOR_VK ? (lang === 'ru' ? plural(price, ['голос', 'голоса', 'голосов'], true) : 'votes') : 'RUB';
}
